import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { UsersComponent } from './users.component';
import { AuthGuard } from '../../../data/services/authGuard';

const routes = [
    {
        path     : 'users',
        component: UsersComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    declarations: [
        UsersComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        UsersComponent
    ]
})

export class FuseUsersModule
{
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/users.module.ts